import Switch from 'rc-switch';
import React, { Fragment } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

function LegendsList({ legendsList,handleSelected, selected }) {    
    return (
        <Fragment>
            <Row className="mt-2">
            <Colxx sm={3} className="mb-3">
                    Aiva Number
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('number')
                                ? true
                                : false}
                        onChange={(primary) => handleSelected('number')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Voucher Name
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('name')
                                ? true
                                : false}
                        onChange={(primary) => handleSelected('name')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Voucher Image
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                        checked={selected !== undefined && selected !== null && selected
                            .split(',')
                            .includes('image')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('image')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Voucher Details
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('details')
                                ? true
                                : false}
                        onChange={(primary) => handleSelected('details')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Voucher Conditions
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('conditions')
                                ? true
                                : false}
                        onChange={(primary) => handleSelected('conditions')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Voucher Instructions
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('instructions')
                                ? true
                                : false}
                        onChange={(primary) => handleSelected('instructions')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Hotel Name
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('hotelName')
                                ? true
                                : false}
                    onChange={(primary) => handleSelected('hotelName')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Hotel Logo
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('hotelLogo')
                                ? true
                                : false}
                    onChange={(primary) => handleSelected('hotelLogo')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Date
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch                       
                              checked={selected !== undefined && selected !== null && selected
                                .split(',')
                                .includes('date')
                                ? true
                                : false}
                    onChange={(primary) => handleSelected('date')}
                    />
                </Colxx>
            </Row>
        </Fragment>
    );
}

export default LegendsList;